import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import { Slider, SubCategoryCarousel, SubCategoryItem } from '../..'
import { useMediaResize } from '../../../utils'

function SubCategorySlider({ subCategories }) {
  const { breakpoints, initialDevice } = useMediaResize()
  const [isMobile, setMobile] = useState(initialDevice === 'mobile')
  const filteredSubCategories = subCategories?.filter(
    ({ include_in_sidebar }) => include_in_sidebar
  )
  useEffect(() => {
    setMobile(breakpoints.downMD)
  }, [breakpoints.downMD])

  if (!filteredSubCategories?.length) {
    return null
  }

  const subCategoriesToRender = filteredSubCategories.map(
    ({ url, name }, index) => (
      <SubCategoryItem
        key={`${url}_${index}`}
        link={url}
        name={name}
        className="sub-category-slider__item"
      />
    )
  )

  return isMobile ? (
    <Slider className="sub-category-slider__mobile my-3">
      {subCategoriesToRender}
    </Slider>
  ) : (
    <div className="container position-relative my-3">
      <SubCategoryCarousel className="sub-category-slider__desktop">
        {subCategoriesToRender}
      </SubCategoryCarousel>
    </div>
  )
}

SubCategorySlider.propTypes = {
  subCategories: PropTypes.array.isRequired,
}

export default SubCategorySlider
export { default as subCategorySliderVariants } from './variants.js'
